import MapLocal from './Map'

const isCallable = (fn) => typeof fn === "function";

export class AbortControllerLocal {
  constructor() {
    this.signal = new EventTargetLocal();
    this.signal.aborted = false;
  }
  abort() {
    if (!this.signal.aborted) {
      this.signal.aborted = true;
      this.signal.dispatchEvent(new Event("abort"));
    }
  }
}

export default class EventTargetLocal {
  constructor() {
    this.listeners = new MapLocal();
  }
  dispatchEvent(event) {
    if (!(event instanceof Event)) {
      throw new TypeError(
        "Failed to execute 'dispatchEvent' on 'EventTarget': parameter 1 is not of type 'Event'."
      );
    }
    const eventType = event.type;
    if (this.listeners.has(eventType)) {
      this.listeners.get(eventType).forEach((handle) => {
        if (typeof handle.listener !== "object") {
          if (isCallable(handle.listener) || handle.listener === undefined) {
            return
          }
          throw new TypeError("Failed to execute 'addEventListener' on 'EventTarget': parameter 2 is not of type 'Object'.")
        }
      })
      this.listeners.get(eventType).forEach((handle) => {
        const { option, listener } = handle;
        if (option && option.once) {
          this.removeEventListener(eventType, listener);
        }
        if (isCallable(listener)) {
          listener(event);
        } else if (listener && isCallable(listener.handleEvent)) {
          listener.handleEvent(event);
        }
      });
    }
  }
  addEventListener(eventType, listener, option) {
    if (arguments.length < 2) {
      throw new TypeError(
        `Failed to execute 'addEventListener' on 'EventTarget': 2 arguments required, but only ${arguments.length} present.`
      );
    }
    const { signal } = Object(option);
    if (signal && signal.aborted) {
      return;
    }
    if (!this.listeners.has(eventType)) {
      this.listeners.set(eventType, []);
    }
    const listeners = this.listeners.get(eventType);
    for (let i = 0; i < listeners.length; i++) {
      if (listeners[i].listener === listener) {
        return;
      }
    }
    listeners.push({
      listener,
      option,
    });
    if (signal) {
      signal.addEventListener(
        "abort",
        () => {
          this.removeEventListener(eventType, listener);
        },
        { once: true }
      );
    }
  }
  removeEventListener(eventType, listener) {
    if (arguments.length < 2) {
      throw new TypeError(
        `Failed to execute 'removeEventListener' on 'EventTarget': 2 arguments required, but only ${arguments.length} present.`
      );
    }
    if (this.listeners.has(eventType)) {
      const listeners = this.listeners
        .get(eventType)
        .filter((item) => item.listener !== listener);
      if (listeners.length) {
        this.listeners.set(eventType, listeners);
      } else {
        this.listeners.delete(eventType);
      }
    }
  }
}

export const globalEvent = new EventTargetLocal()
